import Main from './Main';
import MainContent from './MainContent';
import Footer from './Footer';
import ImportStep from './ImportStep';
import Question from './question';

const Layout = {
  Main,
  MainContent,
  Footer,
  ImportStep,
  Question,
};
export default Layout;
